import React from 'react';

const TestHeader = () => {
  return (
    <div className="max-w-6xl mx-auto">
      <div className="relative mb-12 perspective-1000">
        <div 
          className="bg-white rounded-3xl p-8 shadow-2xl transform hover:rotate-y-2 transition-all duration-700 border border-slate-200"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(240,240,255,0.8) 100%)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
          }}
        >
          <div className="text-center">
            <div 
              className="inline-block px-6 py-2 rounded-full mb-4 text-sm font-semibold"
              style={{
                background: 'linear-gradient(135deg, #01918C 0%, #02c7c0 100%)',
                color: 'white',
                boxShadow: '0 8px 25px rgba(1, 145, 140, 0.3)'
              }}
            >
              Gary Chapman hivatalos tesztje
            </div>
            <h1 
              className="text-4xl lg:text-5xl font-bold mb-4 bg-gradient-to-r from-slate-700 to-slate-900 bg-clip-text text-transparent"
              style={{ lineHeight: '1.2' }}
            >
              Az 5 Szeretetnyelv Teszt
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
              Fedezd fel, hogyan fejezed ki és fogadod be leginkább a szeretetet. 
              30 kérdés, amely segít megérteni saját és partnered szeretetnyelvét.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestHeader;